function open () {
  if (!window.indexedDB) {
    alert("Your browser doesn't support a stable version of IndexedDB.")
    return
  }
  return new Promise((resolve, reject) => {
    const req = window.indexedDB.open('littleStar')
    req.onerror = function (err) {
      alert('IndexedDB open error')
      reject(err)
    }
    req.onsuccess = function () {
      console.log('链接成功')
      resolve(req.result)
    }
    req.onupgradeneeded = function (event) {
      console.log('新建成功')
      const db = event.target.result
      if (!db.objectStoreNames.contains('stars')) {
        db.createObjectStore('stars', { keyPath: 'id' })
      }
      if (!db.objectStoreNames.contains('tags')) {
        db.createObjectStore('tags', { keyPath: 'id' })
      }
      // resolve(db)
    }
  })
}

function get (key, data) {
  return new Promise((resolve, reject) => {
    open().then((db) => {
      const req = db.transaction([key], 'readwrite').objectStore(key).get(data)
      req.onsuccess = function (event) {
        console.log(event.target.result)
        resolve(event.target.result)
      }

      req.onerror = function (err) {
        reject(err)
      }
    })
  })
}

function add (key, data) {
  return new Promise((resolve, reject) => {
    open().then((db) => {
      const req = db.transaction([key], 'readwrite').objectStore(key).add(data)
      req.onsuccess = function (event) {
        resolve(event)
      }

      req.onerror = function (err) {
        reject(err)
      }
    })
  })
}

function update (key, data) {
  return new Promise((resolve, reject) => {
    open().then((db) => {
      const objectStore = db.transaction([key], 'readwrite').objectStore(key)
      const openCursor = objectStore.openCursor(data.id)
      openCursor.onsuccess = function(e) {
        const cursor = e.target.result
        let req
        if (cursor) {
          req = cursor.update(data)
        } else {
          req = objectStore.add(data)
        }
        req.onsuccess = function (event) {
          resolve(event)
        }

        req.onerror = function (err) {
          reject(err)
        }
      }
      openCursor.onerror = function (err) {
        reject(err)
      }
    })
  })
}

function del (key, data) {
  return new Promise((resolve, reject) => {
    open().then((db) => {
      const req = db.transaction([key], 'readwrite').objectStore(key).delete(data)
      req.onsuccess = function (event) {
        resolve(event)
      }

      req.onerror = function (err) {
        reject(err)
      }
    })
  })
}

export default {
  get,
  del,
  update,
  add,
}
